import { ChevronLeftIcon } from '../icons/ChevronLeftIcon';
import { ChevronRightIcon } from '../icons/ChevronRightIcon';
import { useTranslation } from 'react-i18next';
import { ParticipantFace, type ParticipantFaceIdentity } from './ParticipantFace';
import { avatarFrames } from './wizardAvatarFrame';
import './AvatarFramePicker.css';

/** Shared gift frame carousel. The caller decides whether a choice is saved or only previewed. */
export function AvatarFramePicker({ card, index, selectedFrame, onChange, testIdPrefix = 'box-gift-frame', cropped = false }: {
  card?: ParticipantFaceIdentity | null;
  index?: number;
  selectedFrame: string;
  onChange: (name: string) => void;
  testIdPrefix?: string;
  cropped?: boolean;
}) {
  const { t } = useTranslation();
  const selectedIndex = Math.max(0, avatarFrames.findIndex(frame => frame.name === selectedFrame));
  const adjacent = (offset: number) => avatarFrames[(selectedIndex + offset + avatarFrames.length) % avatarFrames.length];
  return <>
    <div className={`box-gift-dialog__frame-picker${cropped ? ' box-gift-dialog__frame-picker--cropped' : ''}`}>
      <button type="button" className="box-gift-dialog__frame-option" onClick={() => onChange(adjacent(-1).name)} aria-label={t('boxGift.previousFrame')} data-testid={`${testIdPrefix}-previous`}><img src={adjacent(-1).src} alt="" /><span aria-hidden="true"><ChevronLeftIcon /></span></button>
      <div className="box-gift-dialog__frame-preview" data-testid={`${testIdPrefix}-preview`} data-frame={avatarFrames[selectedIndex].name}>
        <div className="box-gift-dialog__frame-sparkles" aria-hidden="true">
          {Array.from({ length: 8 }, (_, i) => <span key={i}>✦</span>)}
        </div>
        <ParticipantFace card={card} picture={card?.avatar ? 'custom_avatar' : card?.picture} index={index} frameName={avatarFrames[selectedIndex].name} size="round" />
      </div>
      <button type="button" className="box-gift-dialog__frame-option" onClick={() => onChange(adjacent(1).name)} aria-label={t('boxGift.nextFrame')} data-testid={`${testIdPrefix}-next`}><img src={adjacent(1).src} alt="" /><span aria-hidden="true"><ChevronRightIcon /></span></button>
    </div>
  </>;
}
